import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'Mariela G.',
  location: 'Córdoba',
  quote: "Dejé de vivir con la sensación de 'me va a explotar la tarjeta'. Con el cierre semanal, por fin ajusto sin castigarme."
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  quote: "Lo de 'fijos vs variables' me cambió la cabeza. En una tarde armé mi Semana 1 y ya sé qué tocar y qué no."
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  quote: "No es un curso de finanzas. Es un método realista. Me ordenó comida, compras y esos 'gastos de a poco' que me mataban."
}];
export function Testimonials() {
  return <section className="py-16 bg-white" data-id="element-238">
      <div className="container mx-auto px-4" data-id="element-239">
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-240">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-blue-50 p-6 rounded-2xl border border-blue-200" data-id="element-241">
              <div className="flex items-center gap-3 mb-4" data-id="element-242">
                <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-243">
                  {t.initials}
                </div>
                <div data-id="element-244">
                  <div className="flex gap-0.5 mb-0.5" data-id="element-245">
                    {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-yellow-400 text-yellow-400" data-id="element-246" />)}
                  </div>
                  <div className="text-xs font-bold text-black" data-id="element-247">{t.name}</div>
                  <div className="text-xs text-slate-400" data-id="element-248">{t.location}</div>
                </div>
              </div>
              <p className="text-sm text-slate-700 italic leading-relaxed" data-id="element-249">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}